export default __webpack_public_path__ + "static/media/clickit.d49c33aa.gif";